
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import LinkedInSvg from './svg/LinkedInSvg.vue';

export default defineComponent({
  name: 'LinkedInIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      LinkedInSvg: markRaw(LinkedInSvg)
    };
  }
});
